import {
  AzureOfferPlan,
  AzurePricingType,
  RecurrentPriceModeType,
} from '../../../modules/privateOffer/types'
import { useStyles } from './PlanBillingTerms.styles'
import {
  DetailInfo,
  DetailRow,
} from '../../../common/components/DetailRow/DetailRow'
import { useStyles as usePricingStyles } from '../MicrosoftViewPricing.styles'
import { DisplayNumberValue } from '../PlanMeteringDimensions/PlanMeteringDimensions'
import { getPaymentOptionDisplayValue } from '../getPaymentOptionDisplayValue'
import { getPriceTitleAndValue } from '../getPriceTitleAndValue'

interface PlanBillingTermsProps {
  plan: AzureOfferPlan
  azurePricingType?: AzurePricingType
  recurrentPriceMode?: RecurrentPriceModeType
}

export const PlanBillingTerms = ({
  plan,
  azurePricingType,
  recurrentPriceMode,
}: PlanBillingTermsProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()
  const getContractDuration = () => {
    const prices = plan.pricing?.recurrentPrice?.prices || []
    if (prices.length > 0) {
      const firstPrice = prices[0]
      if (firstPrice?.billingTerm?.value && firstPrice?.billingTerm?.type) {
        return `${firstPrice.billingTerm.value} ${firstPrice.billingTerm.type}`
      }
    }
    return 'Not specified'
  }

  const billingTerm = plan?.pricing?.recurrentPrice?.prices?.[0]?.billingTerm
  const paymentOption =
    plan?.pricing?.recurrentPrice?.prices?.[0]?.paymentOption

  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Billing Terms</div>
      <DetailRow
        borderBottom
        className={classes.billingTermsRow}
        props={{ spacing: 4 }}
      >
        <>
          <DetailInfo
            title="Contract Duration"
            value={getContractDuration()}
            keyName="contractDuration"
            gridSize={4}
          />
          <DetailInfo
            title="Payment terms"
            value={
              !billingTerm || !paymentOption
                ? 'Not specified'
                : paymentOption.type === 'flexible'
                  ? 'Flexible schedule'
                  : getPaymentOptionDisplayValue(billingTerm, paymentOption)
            }
            keyName="paymentOption"
            gridSize={4}
            align="left"
          />
          <DetailInfo
            title={
              getPriceTitleAndValue({
                azurePricingType,
                recurrentPriceMode,
                plan,
              })?.title
            }
            value={
              <DisplayNumberValue
                isPrice
                shouldFormat
                isPrecisionDigit={false}
                value={
                  getPriceTitleAndValue({
                    azurePricingType,
                    recurrentPriceMode,
                    plan,
                  })?.value
                }
              />
            }
            keyName="discountPrice"
            gridSize={4}
            align="flex-end"
          />
        </>
      </DetailRow>
    </div>
  )
}
